export default __webpack_public_path__ + "static/media/rotary_outline.c6f9b7e7.png";